// Class strings of the row drawer. Plain Tailwind utilities with semantic tokens.

/** The box of the row drawer. A column of `minmax(0, 1fr)` keeps it at the width of the drawer, however wide a table inside is. */
export const drawerBox =
  "grid min-w-0 grid-cols-[minmax(0,1fr)] gap-4 rounded-md border-2 border-border bg-card p-4 sm:p-6";

/** A titled section of the drawer. */
export const drawerSection = "grid min-w-0 content-start gap-2";

/** Pairs of a small label over a value (the raw cells, the proposed values). */
export const pairList =
  "m-0 grid gap-2 [&_dd]:m-0 [&_dd]:[overflow-wrap:anywhere] [&_dt]:text-xs [&_dt]:tracking-wide [&_dt]:text-muted-foreground";
